import { t } from "@lingui/macro";
import React from "react";

import { Crementor } from "@whoosh/design-system/src/components/controls/Crementor";
import { Avatar } from "@whoosh/design-system/src/components/display";
import { Text, HStack } from "@whoosh/design-system/src/components/primitive";

type UnknownGuestCounterType = {
  checkNewDisabled?: boolean;
  isDecrementDisabled?: boolean;
  isIncrementDisabled?: boolean;
  unknownGuestLimit?: number;
  unknownGuestCount: number;
  onAddUnknownGuest?: () => void;
  onRemoveUnknownGuest?: () => void;
};

const UnknownGuestCounterSmall = ({
  checkNewDisabled,
  isDecrementDisabled,
  isIncrementDisabled,
  unknownGuestLimit,
  unknownGuestCount,
  onAddUnknownGuest,
  onRemoveUnknownGuest,
}: UnknownGuestCounterType) => {
  return (
    <HStack
      pt={10}
      pb={5}
      mx={6}
      justifyContent="space-between"
      alignItems="center"
      borderBottomWidth={1}
      borderBottomColor="grayscale-200"
      opacity={!unknownGuestCount && checkNewDisabled ? 0.5 : 1}
    >
      <HStack alignItems="center">
        <Avatar type="guest" size="sm" />
        <Text marginLeft={4}>{t`Unknown Guest`}</Text>
      </HStack>
      <Crementor
        min={0}
        max={unknownGuestLimit}
        value={unknownGuestCount}
        onIncrement={onAddUnknownGuest}
        onDecrement={onRemoveUnknownGuest}
        isDecrementDisabled={isDecrementDisabled}
        isIncrementDisabled={isIncrementDisabled}
      />
    </HStack>
  );
};

export default UnknownGuestCounterSmall;
